import { Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { NgTemplateOutlet } from '@angular/common';
import { InstanceLocationComponent } from './location/instance-location.component';
import { Instance } from '../../base/entities/transport.interface';
import { EngineType } from '../../base/entities/engine-type';

@Component({
  selector: 'app-instance',
  standalone: true,
  imports: [InstanceLocationComponent, TranslateModule, ZenithComponentsModule, NgTemplateOutlet],
  templateUrl: './instance.component.html'
})
export class InstanceComponent {

  readonly EngineType = EngineType;

  readonly instance = input.required<Instance>();
  readonly machineIcon = input<false | 'left' | 'right'>('left');
  readonly showBlockedReason = input<boolean>(true);
  readonly showLocation = input<boolean>(true);
  readonly showEngineType = input<boolean>(false);
  readonly showVendor = input<boolean>(false);
  readonly infoClickable = input<boolean>(false);
  @Output() infoClick = new EventEmitter();
}
